<div class="loading-shade" *ngIf="processing"></div>
<div class="modal-scroll">
    <nb-card>
        <nb-card-body>
            <nb-icon icon="close-outline" class="float-right close-button" (click)="ref.close()"></nb-icon>
            <div class="container-fluid p-1 p-sm-5">
                <h6>Split Invoice</h6>
                <p>Split this invoice among multiple buyers. The total split amount must equal the purchased price of the lot.</p>
                <form #f="ngForm" (ngSubmit)="saveSplit(f)">
                  <div class="row mb-1">
                      <div class="col auction-label-text">
                          LOT #
                      </div>
                  </div>

                  <div class="row mb-3">
                      <div class="col">
                          {{ lineItem.lotNum }}
                      </div>
                  </div>

                  <div class="row mb-1">
                      <div class="col auction-label-text">
                          NAME
                      </div>
                  </div>

                  <div class="row mb-3">
                      <div class="col">
                          {{ lineItem.title }}
                      </div>
                  </div>

                  <div class="row mb-1">
                      <div class="col auction-label-text">
                          PURCHASED PRICE
                      </div>
                  </div>

                  <div class="row mb-4">
                      <div class="col">
                          <strong>${{ lineItem.finalPrice }}</strong>
                      </div>
                  </div>

                  <hr>

                  <!-- Original Winning Buyer -->
                  <div class="row mb-1">
                      <div class="col auction-label-text">
                          ORIGINAL WINNING BUYER AMOUNT
                      </div>
                  </div>

                  <div class="row mb-3">
                      <div class="col-3">
                          <input nbInput
                                type="number"
                                [(ngModel)]="originalBuyerAmount"
                                name="originalBuyerAmount"
                                fullWidth
                                (ngModelChange)="onOriginalBuyerAmountChange()"
                                step="0.01"
                                min="0"
                                required>
                      </div>
                      <div class="col-9">
                          <div class="row">
                              <div class="col">
                                  <strong>{{ lineItem.winningBidderFirstName }} {{ lineItem.winningBidderLastName }}</strong>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col">
                                  {{ lineItem.winningBidderEmail }}
                              </div>
                          </div>
                      </div>
                  </div>

                  <hr>

                  <!-- Split Users -->
                  <div class="row mb-2">
                      <div class="col auction-label-text">
                          ADDITIONAL BUYERS
                      </div>
                  </div>

                  <div *ngFor="let splitUser of splitUsers; let i = index" class="split-user-section mb-4">
                      <div class="row mb-2">
                          <div class="col-10">
                              <strong>Buyer {{ i + 1 }}</strong>
                          </div>
                          <div class="col-2 text-right">
                              <button nbButton ghost size="small" status="danger" (click)="removeSplitUser(i)" *ngIf="splitUsers.length > 0" type="button">
                                  <nb-icon icon="trash-2-outline"></nb-icon>
                              </button>
                          </div>
                      </div>

                      <div class="row mb-2">
                          <div class="col-3 auction-label-text">
                              AMOUNT ($)
                          </div>
                          <div class="col-9">
                              <input nbInput
                                    type="number"
                                    [(ngModel)]="splitUsers[i].amount"
                                    [name]="'amount' + i"
                                    fullWidth
                                    (ngModelChange)="onSplitUserAmountChange(i)"
                                    step="0.01"
                                    min="0"
                                    required>
                          </div>
                      </div>

                      <div class="row mb-2">
                          <div class="col-3 auction-label-text">
                              FIRST NAME
                          </div>
                          <div class="col-9">
                              <input nbInput
                                    [(ngModel)]="splitUsers[i].firstName"
                                    [name]="'firstName' + i"
                                    fullWidth
                                    required>
                          </div>
                      </div>

                      <div class="row mb-2">
                          <div class="col-3 auction-label-text">
                              LAST NAME
                          </div>
                          <div class="col-9">
                              <input nbInput
                                    [(ngModel)]="splitUsers[i].lastName"
                                    [name]="'lastName' + i"
                                    fullWidth
                                    required>
                          </div>
                      </div>

                      <div class="row mb-2">
                          <div class="col-3 auction-label-text">
                              EMAIL
                          </div>
                          <div class="col-7">
                              <input nbInput
                                    type="email"
                                    [(ngModel)]="splitUsers[i].email"
                                    [name]="'email' + i"
                                    fullWidth
                                    required>
                          </div>
                          <div class="col-2">
                              <button nbButton ghost size="small" status="primary" (click)="openUserLookup(i)" type="button" title="Lookup User">
                                  <nb-icon icon="search-outline"></nb-icon>
                              </button>
                          </div>
                      </div>

                      <div class="row mb-2">
                          <div class="col-3 auction-label-text">
                              PHONE NUMBER
                          </div>
                          <div class="col-9">
                              <input nbInput
                                    [(ngModel)]="splitUsers[i].phoneNumber"
                                    [name]="'phoneNumber' + i"
                                    fullWidth
                                    required>
                          </div>
                      </div>

                      <div class="row mb-2">
                          <div class="col-3 auction-label-text">
                              ADDRESS LINE 1
                          </div>
                          <div class="col-9">
                              <input nbInput
                                    [(ngModel)]="splitUsers[i].address[0]"
                                    [name]="'address1' + i"
                                    fullWidth
                                    required>
                          </div>
                      </div>

                      <div class="row mb-2">
                          <div class="col-3 auction-label-text">
                              ADDRESS LINE 2
                          </div>
                          <div class="col-9">
                              <input nbInput
                                    [(ngModel)]="splitUsers[i].address[1]"
                                    [name]="'address2' + i"
                                    fullWidth>
                          </div>
                      </div>
                  </div>

                  <div class="row mb-3">
                      <div class="col">
                          <button nbButton ghost size="small" status="primary" (click)="addSplitUser()" type="button">
                              <nb-icon icon="plus-outline"></nb-icon> Add Buyer
                          </button>
                      </div>
                  </div>

                  <hr>

                  <!-- Total Validation -->
                  <div class="row mb-2">
                      <div class="col-6 auction-label-text">
                          TOTAL SPLIT AMOUNT:
                      </div>
                      <div class="col-6">
                          <strong [ngClass]="{'text-danger': !isValidSplit, 'text-success': isValidSplit}">
                              ${{ totalSplit | number:'1.2-2' }}
                          </strong>
                      </div>
                  </div>

                  <div class="row mb-3">
                      <div class="col-6 auction-label-text">
                          PURCHASED PRICE:
                      </div>
                      <div class="col-6">
                          <strong>${{ lineItem.finalPrice | number:'1.2-2' }}</strong>
                      </div>
                  </div>

                  <div class="row mb-4" *ngIf="!isValidSplit">
                      <div class="col">
                          <p class="text-danger">
                              <nb-icon icon="alert-circle-outline"></nb-icon>
                              The split total must equal the purchased price.
                          </p>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col align-items-center">
                          <button type="submit" [nbSpinner]="processing" nbButton size="medium" status="primary" [disabled]="!f.valid || !isValidSplit">Save</button>
                          <a class="back-link-text ml-2" (click)="ref.close()">Cancel</a>
                      </div>
                  </div>
                </form>
            </div>
        </nb-card-body>
    </nb-card>
</div>
